"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cache = void 0;
const StorageCache_1 = require("./StorageCache");
exports.Cache = new StorageCache_1.StorageCache();
